<template>
    <div class="blog-user" :class="{ 'no-blog': my_blogs.length == 0 }">
        <div v-if="load">
            <div v-if="user.user_uuid == idt" class="add-button" @click="newBlog">
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask
                        id="mask0_19_1554"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="25"
                        height="25"
                    >
                        <rect x="0.15918" y="0.538513" width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_19_1554)">
                        <path
                            d="M11.6592 17.0385H12.6592V13.0385H16.6592V12.0385H12.6592V8.03851H11.6592V12.0385H7.65918V13.0385H11.6592V17.0385ZM12.1592 21.5385C10.9092 21.5385 9.73851 21.3012 8.64718 20.8265C7.55518 20.3512 6.60518 19.7092 5.79718 18.9005C4.98851 18.0925 4.34651 17.1425 3.87118 16.0505C3.39651 14.9592 3.15918 13.7885 3.15918 12.5385C3.15918 11.2885 3.39651 10.1175 3.87118 9.02551C4.34651 7.93418 4.98851 6.98418 5.79718 6.17551C6.60518 5.36751 7.55518 4.72585 8.64718 4.25051C9.73851 3.77585 10.9092 3.53851 12.1592 3.53851C13.4092 3.53851 14.5802 3.77585 15.6722 4.25051C16.7635 4.72585 17.7135 5.36751 18.5222 6.17551C19.3302 6.98418 19.9718 7.93418 20.4472 9.02551C20.9218 10.1175 21.1592 11.2885 21.1592 12.5385C21.1592 13.7885 20.9218 14.9592 20.4472 16.0505C19.9718 17.1425 19.3302 18.0925 18.5222 18.9005C17.7135 19.7092 16.7635 20.3512 15.6722 20.8265C14.5802 21.3012 13.4092 21.5385 12.1592 21.5385ZM12.1592 20.5385C14.3925 20.5385 16.2842 19.7635 17.8342 18.2135C19.3842 16.6635 20.1592 14.7718 20.1592 12.5385C20.1592 10.3052 19.3842 8.41351 17.8342 6.86351C16.2842 5.31351 14.3925 4.53851 12.1592 4.53851C9.92585 4.53851 8.03418 5.31351 6.48418 6.86351C4.93418 8.41351 4.15918 10.3052 4.15918 12.5385C4.15918 14.7718 4.93418 16.6635 6.48418 18.2135C8.03418 19.7635 9.92585 20.5385 12.1592 20.5385Z"
                            fill="white"
                        />
                    </g>
                </svg>
                <p style="color: white; cursor: pointer">Add new Blog</p>
            </div>

            <div class="blog-list" :class="{ 'add-button-blogs': my_blogs.length > 0 }">
                <div v-for="(blog, index) in my_blogs" :key="blog.blog_post_uuid" class="blog-list-margin">
                    <div class="blog-cart">
                        <div class="blog-cart-picture">
                            <img
                                v-if="blog.image && blog.image.startsWith('fra1')"
                                class="opacity_7"
                                :src="`https://api.outpostchess.com/upload/w_150,ao_1/https://` + blog.image"
                                alt="blog_image"
                                @click="innerBlog(blog, index)"
                            />
                            <img
                                v-else-if="blog.image && !blog.image.startsWith('fra1')"
                                class="opacity_7"
                                :src="`https://api.outpostchess.com/upload/w_150,ao_1/` + blog.image"
                                alt="blog_image"
                                @click="innerBlog(blog, index)"
                            />

                            <img
                                v-else
                                class="opacity_7"
                                src="../../assets/NAT.jpg"
                                alt="blog_image"
                                @click="innerBlog(blog, index)"
                            />
                        </div>
                        <div class="blog-card_bottom">
                            <div>
                                <!--<h3 v-if="blog.title.length>22">{{ blog.title.substring(0, 22) }}...</h3>-->
                                <h3 class="opacity_7" @click="innerBlog(blog, index)">
                                    {{ blog.title }}
                                </h3>
                                <!--      <p style="word-break: break-all" v-if="blog.description.length > 55">
                                    {{ blog.description.substring(0, 55) }}...
                                </p>   -->
                                <p class="three-line" style="word-break: break-all">
                                    {{ blog.description }}
                                </p>
                            </div>
                            <div class="bottom_options">
                                <div class="read-more-btn mobile" @click="innerBlog(blog, index)">
                                    <p class="read-more">Read more</p>

                                    <svg
                                        width="15"
                                        height="11"
                                        viewBox="0 0 15 11"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9.74618 10.531L9.0774 9.86222L12.9706 5.9451H0.669922V4.98971H12.9706L9.0774 1.07259L9.74618 0.403809L14.8098 5.4674L9.74618 10.531Z"
                                            fill="#11C6D1"
                                        />
                                    </svg>
                                </div>

                                <svg
                                    v-if="idt == user.user_uuid"
                                    class="edit-svg"
                                    width="40"
                                    height="40"
                                    viewBox="0 0 43 42"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    @click="editBlog(blog)"
                                >
                                    <circle cx="21.8585" cy="21.0919" r="20.8702" fill="#D9D9D9" fill-opacity="0.05" />
                                    <mask
                                        id="mask0_1608_19899"
                                        style="mask-type: alpha"
                                        maskUnits="userSpaceOnUse"
                                        x="9"
                                        y="9"
                                        width="25"
                                        height="25"
                                    >
                                        <rect x="9.8584" y="9.09277" width="24" height="24" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_1608_19899)">
                                        <path
                                            d="M14.8584 28.0928H16.2584L24.8834 19.4678L23.4834 18.0678L14.8584 26.6928V28.0928ZM29.1584 18.0178L24.9084 13.8178L26.3084 12.4178C26.6917 12.0344 27.1627 11.8428 27.7214 11.8428C28.2794 11.8428 28.7501 12.0344 29.1334 12.4178L30.5334 13.8178C30.9167 14.2011 31.1167 14.6638 31.1334 15.2058C31.1501 15.7471 30.9667 16.2094 30.5834 16.5928L29.1584 18.0178ZM27.7084 19.4928L17.1084 30.0928H12.8584V25.8428L23.4584 15.2428L27.7084 19.4928Z"
                                            fill="#6F7381"
                                        />
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DOMPurify from "dompurify";
import { marked } from "marked";
export default {
    name: "BlogUser",
    props: ["user", "changeBlog"],

    data() {
        return {
            show: true,
            my_blogs: [],
            blogs: [],
            innerTitle: "",
            innerDesc: "",
            innerContent: "",
            innerPic: "",
            editor1: "",
            idt: "",
            load: true,
        };
    },
    computed: {
        markdownContent() {
            return DOMPurify.sanitize(marked.parse(this.innerContent));
        },
    },
    watch: {
        changeBlog() {
            this.newData();
        },
    },
    created() {
        this.idt = localStorage.getItem("id");

        if (this.user.user_uuid == this.idt) {
            fetch(process.env.VUE_APP_URL + `/blog_posts_by_user/${this.idt} `, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then(response => response.json())
                .then(data => (this.my_blogs = data))
                // .then(data => console.log("my blogs", data))
                .then(this.setStoreBlogs);
        } else {
            fetch(process.env.VUE_APP_URL + `/blog_posts_by_user/${this.user.user_uuid} `, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then(response => response.json())
                .then(data => (this.my_blogs = data))
                // .then(data => console.log("my blogs", data))
                .then(this.setStoreBlogs);
        }
    },
    methods: {
        newData() {
            if (this.user.user_uuid == this.idt) {
                fetch(process.env.VUE_APP_URL + `/blog_posts_by_user/${this.idt} `, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                    .then(response => response.json())
                    .then(data => (this.my_blogs = data))
                    // .then(data => console.log("my blogs", data))
                    .then(this.setStoreBlogs);
            } else {
                fetch(process.env.VUE_APP_URL + `/blog_posts_by_user/${this.user.user_uuid} `, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                    .then(response => response.json())
                    .then(data => (this.my_blogs = data))
                    //.then(data => console.log("my blogs", data))
                    .then(this.setStoreBlogs);
            }
        },
        setStoreBlogs() {
            // this.load = true;
            this.$store.commit("SET_MY_BLOGS", this.my_blogs);
        },
        innerBlog(e, index) {
            this.$store.commit("SET_BLOG_VIEW_PROFILE", e);
            //  console.log(index);
            this.$router.push({ name: "HomeBlogView", params: { id: e.blog_post_uuid, index: index } });
            //this.$emit("popUp", e, index);
            //  const newURL = e.blog_post_uuid ;
            // window.history.pushState({}, '',`/publicprofile/${e.created_by}`+ `/${newURL}` );
        },
        editBlog(e) {
            this.$router.push({ name: "BlogCreate", params: { id: e.blog_post_uuid } });
            //this.$emit("popupAdd", e);
        },

        SetValueText(text) {
            // console.log("1", text);
            this.content_md = text;
        },

        newBlog() {
            this.$router.push({ name: "BlogCreate", params: { plan: 1 } });
            //   this.$emit("popupAdd", 1);
        },
    },
};
</script>

<style scoped lang="scss">
// TRANSITION

.fade-enter-active {
    transition: opacity 0.5s;
}
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.blog-user {
    padding: 15px 1.875rem;
    overflow: scroll;
    max-height: 650px;
    transition: 0s !important;
}
.no-blog {
    align-items: center;
}
.innner-blog-left {
    padding: 40px;
    p {
        padding-top: 20px;
        text-align: start;
    }
    h3 {
        text-align: start;
    }
}
h3 {
    color: rgba(17, 198, 209, 1);
    font-size: 16px !important;
    display: block;
    // white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.edit-svg:hover {
    cursor: pointer;
    opacity: 0.7;
}
.fade-leave-active {
    transition: opacity 0.5s ease;
}
.read-more {
    color: #c8a07d !important;
    margin-top: 0px !important;
}
.read-more:hover {
    opacity: 0.7;
    cursor: pointer;
}

.fade-leave-to,
.fade-enter-from {
    opacity: 0;
}
h3 {
    font-size: 1.5rem;
}
.bottom_options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
        display: flex;
        align-items: center;
        svg {
            margin-left: 6px;
            opacity: 1;
            transition: 0.5s;
        }
    }
    /*  div:hover {
        svg {
            opacity: 1;
            transition: 0.5s;
        }
    }  */
    p:last-child {
        padding-right: 15px;
    }
    p:hover {
        cursor: pointer;
        opacity: 0.7;
    }
}
svg:hover {
    fill: #5c5e64;
}

.read-more-btn {
    cursor: pointer;
    border: 1px solid #c8a07d;
    border-radius: 6px;
    width: 139px !important;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.arrow-inner {
    display: flex;
    justify-content: flex-start;
    padding: 12px;
}
.arrow-inner:hover {
    opacity: 0.7;
    cursor: pointer;
}
.add-button-blogs {
    margin-top: 20px;
}
.add-button {
    border: 0.5px solid rgba(111, 115, 129, 0.5);
    border-radius: 100px;
    width: 155px;
    height: 34px;
    margin-bottom: 30px;
    padding: 5px 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-right: 15px;
    p {
        padding-left: 6px;
    }
    @media screen and (max-width: 640px) {
        margin-bottom: 0px;
    }
}
.three-line {
    text-overflow: ellipsis !important;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.blog-cart-picture {
    width: 100%;
}
.add-button:hover {
    border: 0.5px solid #c8a07d;
    cursor: pointer;
}
.blog-list {
    padding: 12px 0;
    display: grid;
    justify-items: center;
    grid-template-columns: 48% 48%;
    grid-row-gap: 16px;
    grid-column-gap: 16px;
    transition: 0s !important;
    img {
        width: 100%;
        height: 175px;
        object-fit: cover;
    }
    div {
        width: 100%;
    }
    @media screen and (max-width: 640px) {
        padding: 0px 0 !important;
    }
}
.blog-cart {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #1b1c1f;
    height: 360px;
    border: 1px solid rgba(255, 255, 255, 0.2);

    p {
        text-align: start;
    }
    h3 {
        text-align: start;
    }
}

.blog-card_bottom {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1.575rem 12px 8px 18px;
    height: 100%;

    p {
        margin-top: 6px;
    }
}

.error {
    border: 0.5px solid #f2358d !important;
}

@media screen and (max-width: 640px) {
    .blog-user {
        padding-left: 2.917rem;
        padding-right: 0;
        overflow: auto;
        min-height: 73px;
        max-height: 5250px;
        display: flex;
    }
    .blog-list {
        padding: 6px 0;
        display: block !important;
    }
    .blog-list-margin {
        margin-bottom: 18px;
    }
    .blog-card_bottom {
        div {
            p {
                color: rgba(255, 255, 255, 1);
            }
        }
    }
}
</style>
